import './notification-item.scss';

import type { IHeaderNotification } from './types';

interface IProps {
  notification: IHeaderNotification;
  onClick: (notificationId: string) => void;
}

const NotificationItem: React.FC<IProps> = ({ notification, onClick }) => {
  const itemClass = [
    'notification-item',
    !notification.isRead ? 'notification-item--unread' : ''
  ].join(' ');

  const indicatorClass = [
    'notification-item__indicator',
    `notification-item__indicator--${notification.kind}`
  ].join(' ');

  return (
    <button
      type="button"
      className={itemClass}
      onClick={() => onClick(notification.id)}
    >
      <span className={indicatorClass} />
      <span className="notification-item__content">
        <span className="notification-item__title">{notification.title}</span>
        <span className="notification-item__description">
          {notification.description}
        </span>
        <span className="notification-item__time">
          {notification.createdAtLabel}
        </span>
      </span>
    </button>
  );
};

export default NotificationItem;
